{
  "GENERAL": {
    "CLOSE": "Uždaryti",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Ieškoti",
      "EMPTY_STATE": "Nieko nerasta"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Būtina bent {count}"
  }
}
